import styled from '@emotion/styled'
import { Line } from 'app/components/Common/Line'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo } from 'react'

import { Includes } from './Includes'
import { Info } from './Info'
import { Terms } from './Terms'

export interface Props {
  description?: string
  includes?: string
  languageCode: string
  price?: string
  terms?: string
  title?: string
  validity?: string
}

export const OfferIntro = memo(function OfferIntro({
  description,
  includes,
  languageCode,
  price,
  terms,
  title,
  validity,
}: Props) {
  return (
    <Container row space="between" tag="section" wrap>
      <LeftSide>
        <Info price={price} validity={validity} />

        {title ? (
          <Title>
            {title}
            <Line />
          </Title>
        ) : null}
        {description ? (
          <Description dangerouslySetInnerHTML={{ __html: description }} />
        ) : null}

        <Terms languageCode={languageCode} terms={terms} />
      </LeftSide>
      <RightSide>
        <Includes includes={includes} languageCode={languageCode} />
      </RightSide>
    </Container>
  )
})

const Container = styled(FlexBox)``

const LeftSide = styled.div`
  width: 50%;
  padding: 4.5rem 0 6.5625rem 10.556vw;

  @media (max-width: 1199px) {
    padding: 3.75rem 0 0 1.875rem;
  }

  @media (max-width: 1023px) {
    width: 100%;
    padding-right: 1.875rem;
  }

  @media (max-width: 767px) {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
`

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 2.25rem;
  font-weight: 600;
  line-height: 2.875rem;

  > div {
    margin-top: 0.625rem;
  }
`

const Description = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralDark4};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 1.0625rem;
  line-height: 1.875rem;
  margin-top: 2.5rem;

  @media (max-width: 1199px) {
    font-size: 1rem;
    line-height: 1.75rem;
  }
`

const RightSide = styled.div`
  width: calc(50% - 8.819vw);
  background: ${({ theme }) => theme.colors.variants.neutralLight3};
  padding: 5.125rem 10.556vw 8.125rem 6.736vw;

  @media (max-width: 1199px) {
    width: calc(50% - 3.75rem);
    padding: 4.375rem 1.875rem 4.375rem 3rem;
  }

  @media (max-width: 1023px) {
    width: 100%;
    margin-top: 3.75rem;
    padding-left: 1.875rem;
  }

  @media (max-width: 767px) {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
`
